<template>
<v-card tile >
  <v-card-title class="overline py-0 grey lighten-4" >
    {{title}}
    <v-spacer />
    <v-chip small outlined label v-if="objectUsername" >
      {{ objectUsername }}
    </v-chip>
  </v-card-title>
  <v-divider/>

  <set-username
    v-if="settings && settings.slug"
    :initial-username="settings.slug"
    :locked="settings.username_locked"
    :context="objectType"
    :object-id="objectId" />

  <!-- <asset-settings
    v-if="false"
    @close="editMode=false"
    :object-type="objectType"
    :practitioner="practitioner"
    :space="space"
    :id-path="idPath" /> -->

  <v-list dense class="pa-0" >

    <!-- email alias-->
    <v-list-item v-if="objectType==='practitioner'" >
      <v-list-item-action >
        <v-icon >mdi-email</v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title  >
          Email Alias
          <help-popover small >
            AppointmentGuru creates a free email alias for you which forwards to your preferred email address.
            By default, when sending email on your behalf, AppointmentGuru will use this email address in order to improve deliverability
          </help-popover>
        </v-list-item-title>
        <v-list-item-subtitle >
        <v-btn x-small text class="pa-0" >
          {{settings.sub_domain}}@appt.guru
          <v-icon x-small
            @click="copy(`${settings.sub_domain}@appt.guru`)" class="ml-1" >mdi-content-copy</v-icon>

          <v-icon x-small class="mx-1" >mdi-arrow-right</v-icon>

          {{settings.email_forward_alias}}
          <v-icon x-small
            @click="copy(settings.email_forward_alias)"
            class="ml-1" >mdi-content-copy</v-icon>
        </v-btn>
        </v-list-item-subtitle>

      </v-list-item-content>

      <v-list-item-action class="mr-2" >
        <v-btn small icon color="info" ><v-icon right >mdi-pencil</v-icon></v-btn>
        <v-list-item-action-text >Edit</v-list-item-action-text>
      </v-list-item-action>

    </v-list-item>
    <v-divider/>

    <v-list-item v-if="websiteURL" >
      <v-list-item-action >
        <v-icon >mdi-web</v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title v-if="objectType==='practitioner'" >
          Personal web page
          <v-chip x-small outlined label
            v-if="settings.is_website_published"
            color="primary" class="ml-2" >published</v-chip>
          <v-chip v-else x-small outlined label
            color="warning" class="ml-2" >not published</v-chip>
        </v-list-item-title>
        <v-list-item-title v-if="objectType==='space'" >
          Business web page
        </v-list-item-title>
        <v-list-item-subtitle >
          <v-btn x-small text class="pa-0" @click="copy(websiteURL)" >
            {{websiteURL}}
            <v-icon x-small class="ml-2" >mdi-content-copy</v-icon>
          </v-btn>
        </v-list-item-subtitle>
      </v-list-item-content>

      <template v-if="object.website_published" >
        <v-list-item-action >
          <v-btn icon ><v-icon right class="mr-2" >mdi-power-off</v-icon></v-btn>
          <v-list-item-action-text >Publish</v-list-item-action-text>
        </v-list-item-action>
        <v-list-item-action >
          <v-icon right >mdi-open-in-new</v-icon>
          <v-list-item-action-text >View</v-list-item-action-text>
        </v-list-item-action>
      </template>
      <v-list-item-action v-else >
        <v-btn icon color="info" ><v-icon right class="mr-2" >mdi-power</v-icon></v-btn>
        <v-list-item-action-text >Publish</v-list-item-action-text>
      </v-list-item-action>
    </v-list-item>

    <v-divider/>
    <v-list-item >

      <v-list-item-action >
        <v-icon >mdi-calendar</v-icon>
      </v-list-item-action>
      <v-list-item-content>

        <v-list-item-title>
          <template v-if="objectType==='practitioner'">
            Personal booking widget
          </template>
          <template v-if="objectType==='space'">
            Business booking widget
          </template>
          <!-- <v-btn small icon class="pa-0" >
            <v-icon small >mdi-pencil</v-icon>
          </v-btn> -->
        </v-list-item-title>
        <v-list-item-subtitle @click="copy(widgetURL)" >
          {{widgetURL}}
          <v-icon x-small class="ml-2" >mdi-content-copy</v-icon>
        </v-list-item-subtitle>

      </v-list-item-content>

      <v-list-item-action >
        <v-btn icon @click="dialogs.embed=true" ><v-icon >mdi-code-tags</v-icon></v-btn>
        <v-list-item-action-text >Embed</v-list-item-action-text>
      </v-list-item-action>

      <v-list-item-action >
        <v-btn icon target="_blank" :href="widgetURL" >
        <v-icon right >mdi-open-in-new</v-icon>
        </v-btn>
        <v-list-item-action-text >View</v-list-item-action-text>
      </v-list-item-action>

    </v-list-item>

    <template v-if="calendarFeed" >
      <v-divider/>
      <v-list-item >
        <v-list-item-action >
          <v-icon >mdi-calendar-feed</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            Calendar feed
          </v-list-item-title>
          <v-list-item-subtitle @click="copy(calendarFeed)" >
            {{calendarFeed}}
            <v-icon x-small class="ml-2" >mdi-content-copy</v-icon>
          </v-list-item-subtitle>

          <v-list-item-subtitle >
            Share this feed to add your AppointmentGuru calendar to your device's calendar
          </v-list-item-subtitle>

        </v-list-item-content>
        <v-list-item-action >
          <v-btn small text
            href="https://help.appointmentguru.co/sync-to-a-phone-calendar-app.html"
            target="_blank" >Learn more
            <v-icon small class="ml-2" >mdi-open-in-new</v-icon>
          </v-btn>
        </v-list-item-action>

      </v-list-item>
    </template>

  </v-list>

  <!-- dialogs -->
  <template >
    <v-dialog v-model="dialogs.embed" >
      <v-card >
        <v-card-title class='overline py-0 grey lighten-4' >
          Embed a booking widget on your website
          <v-spacer/>
          <v-btn small icon @click="dialogs.embed=false" ><v-icon small>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text >
          <v-row >
            <v-col>
              <v-card outlined
                @click="copy(embedText)" class="pa-3" >
                <v-alert tile type="info" class="caption" >
                  Give this code to your developer to embed a booking widget on your website.<br/>
                  This widget is for the specific practitioner.
                </v-alert>
                <pre class="caption" >{{embedText}}</pre>
                <v-divider />
                <v-card-actions >
                  <v-spacer />
                  <v-btn text small >Click to copy code
                    <v-icon small class="ml-2">mdi-content-copy</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col>
              <v-card flat>
                <v-card-title class='overline grey lighten-4 py-1' >
                  <v-icon small class="mr-2" >mdi-eye-outline</v-icon>
                  Peview
                </v-card-title>
                <iframe
                  :src="widgetURL"
                  style="border: 0px;box-shadow: 0 1px 3px rgba(0,0,0,.2),0 1px 1px rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12)!important;"
                  width="100%" height="400px" >
                </iframe>
              </v-card>

            </v-col>
          </v-row>
        </v-card-text>

      </v-card>
    </v-dialog>
  </template>
  <v-snackbar v-model="alerts.embedcopied" info >
    Copied to clipboard
    <v-btn outlined x-small
      class="float-right"
      @click="alerts.embedcopied=false" >close</v-btn>
  </v-snackbar>
</v-card>
</template>
<script>
import HelpPopover from '@/components/ui/HelpPopover.vue'
// import AssetSettings from './AssetSettings.vue'
import SetUsername from './assets/SetUsername.vue'

export default {
  name: 'MemberAsset',
  props: {
    object: { type: Object },
    settings: { type: Object },
    objectType: { type: String, default: 'practitioner' }
  },
  components: {
    // AssetSettings,
    HelpPopover,
    SetUsername
  },
  data () {
    return {
      dialogs: {
        embed: false
      },
      alerts: {
        embedcopied: false
      },
      username: null,
      editMode: false
    }
  },
  computed: {
    objectId() {
      return this.getObjectPath(this.object, 'id')
    },
    title () {
      if (this.objectType === 'space' && this.object) { return this.object.title }
      if (this.objectType === 'practitioner' && this.object) {
        return `${this.object.first_name} ${this.object.last_name}`
      }
      return 'Assets'
    },
    objectUsername() {
      let slug = this.getObjectPath(this.settings, 'slug')
      return this.getObjectPath(this.settings, 'sub_domain', slug)
    },
    widgetURL () {
      return this.getWidgetURL(this.objectType, this.objectId)
    },
    websiteURL () {
      return this.getWebsiteURL(this.objectType, this.settings)
    },
    calendarFeed () {
      if (this.practitioner && this.practitioner.channel) {
        return this.getCalendarFeedURL(this.practitioner.id)
      }
      return null
    },
    embedText () {
      return `<iframe
  src="${this.widgetURL}"
  style="border: 0px;box-shadow: 0 1px 3px rgba(0,0,0,.2),0 1px 1px rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12)!important;"
  width="100%" height="400px" >
</iframe>`
    }
  },
  methods: {
    copy (text) {
      let vm = this
      if (navigator && navigator.clipboard) {
        navigator.clipboard.writeText(text).then(() => {
          vm.alerts.embedcopied = true
        })
      } else {
        window.alert("Copying to clipboard is not supported by this browser")
      }
    }
  }
}
</script>
